<template lang="html">

  <section class="add-genre">
    <AdminHeader></AdminHeader>
    <h1 class="mb-5">Genre hinzufügen</h1>
    <v-text-field outlined v-model="name" label="Name"></v-text-field>
    <v-btn  v-if="$route.params.id" @click="editGenre" class="button">Bearbeiten</v-btn>
    <v-btn  v-else @click="addGenre" class="button">Hinzufügen</v-btn>
  </section>

</template>

<script lang="js">
import GenreService from "../../services/GenreService";
import AdminHeader from "./AdminHeader";

export default {
  name:       'add-genre',
  components: {AdminHeader},
  props:      [],
  mounted () {
    this.getGenre();
  },
  data () {
    return {
      'name': "",
    }
  },
  methods:    {
    addGenre () {
      GenreService.addGenre(this.name)
                  .then(res => {
                    console.log(res);
                    this.$router.push("/admin/genres");
                  })
                  .catch(err => console.log(err));
    },
    getGenre () {
      GenreService.getGenre(this.$route.params.id).then((res) => {
        this.name = res.data.name;
      })
    },
    editGenre () {
      GenreService.updateGenre(this.$route.params.id, this.name)
                  .then(res => {
                    console.log(res);
                    this.$router.push("/admin/genres");
                  })
                  .catch(err => console.log(err));
    }
  },
  computed:   {}
}


</script>

<style scoped lang="scss">
.add-genre {

}
</style>
